import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { decodeToken } from 'react-jwt'
import { FilterData } from '../../components/Filter/FilterData'

//creating a type description interface
export interface AuthState {
    authData: {
        accessToken: string | null
        username: string | null
        partner: string | null
        partnername: string | null
        accesslevel: string | null
        error: string | null
    }
}

export interface decodedToken {
    iat: number
    nbf: number
    exp: number
    iss: string
    aud: string
    sub: string
    username: string
    partner: any
    partnername: any
    accesslevel: string
}

//Get current date for using it default in filters
const today = new Date();
const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0');
const day = String(today.getDate()).padStart(2, '0');
const hours = String(today.getHours()).padStart(2, '0');
const minutes = String(today.getMinutes()).padStart(2, '0');
const dateTimeString = `${year}-${month}-${day} ${hours}:${minutes}`;
const dateString = `${year}-${month}-${day}`;

//The initial state is taken from localstorage, if there is none - null
const initialState: any = {
    filterUserData: {
        contacts: localStorage.getItem('contacts_filter') ? JSON.parse(localStorage.getItem('contacts_filter') || '[]') : [{ "name": "Lead Date", "params": [{ "type": "leaddatefrom", "label": "Lead date from", "value": dateString, "input": "date" }, { "type": "leaddateto", "label": "Lead date to", "value": dateString, "input": "date" }] }],
        contactreport: localStorage.getItem('contactreport_filter') ? JSON.parse(localStorage.getItem('contactreport_filter') || '[]') : [{ "name": "Call date", "params": [{ "type": "calldatefrom", "label": "Call date from", "value": dateString, "input": "datetime" }, { "type": "calldateto", "label": "Call date to", "value": dateTimeString, "input": "datetime" }] }],
        calls: localStorage.getItem('calls_filter') ? JSON.parse(localStorage.getItem('calls_filter') || '[]') : [{"name":"Call date","params":[{"type":"df","label":"Call date from","value": dateString,"input":"datetime"},{"type":"dt","label":"Call date to","value": dateTimeString,"input":"datetime"}]}],
        callreport: localStorage.getItem('callreport_filter') ? JSON.parse(localStorage.getItem('callreport_filter') || '[]') : [{"name":"Call date","params":[{"type":"calldatefrom","label":"Call date from","value": dateString,"input":"datetime"},{"type":"calldateto","label":"Call date to","value": dateTimeString,"input":"datetime"}]}],
        conversation: localStorage.getItem('conversation_filter') ? JSON.parse(localStorage.getItem('conversation_filter') || '[]') : [{"name":"Conversation date","params":[{"type":"df","label":"Conversation date from","value": dateString,"input":"datetime"},{"type":"dt","label":"Conversation date to","value": dateTimeString,"input":"datetime"}]}],
        conversationreport: localStorage.getItem('conversationreport_filter') ? JSON.parse(localStorage.getItem('conversationreport_filter') || '[]') : [{"name":"Conversation date","params":[{"type":"df","label":"Conversation date from","value": dateString,"input":"datetime"},{"type":"dt","label":"Conversation date to","value": dateTimeString,"input":"datetime"}]}],
        conversationdetail: localStorage.getItem('conversationdetail_filter') ? JSON.parse(localStorage.getItem('conversationdetail_filter') || '[]') : [{ name: "Conversation date", params: [{ type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime" }, { type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime" }] }],
        optimizationtemplate: localStorage.getItem('optimizationtemplate_filter') ? JSON.parse(localStorage.getItem('optimizationtemplate_filter') || '[]') : [{ name: "Conversation date", params: [{ type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime" }, { type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime" }] }],
        chart: [],

    }
}

const setValue = (type: any, value: any, data: any) => {
    return data.map((filter: any) => {
        return Object.assign({}, filter, {
            params: filter.params.map((param: any) => {
                if (param.type === type) {
                    return Object.assign({}, param, { value });
                } else {
                    return param;
                }
            })
        });
    });
};
//Creating a slice with state interaction functions

export const filterReducer = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        addContactFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                contacts: [
                    ...state.filterUserData.contacts,
                    action.payload
                ]
            }
        }),
        deleteContactFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                contacts: state.filterUserData.contacts.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeContactFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                contacts: setValue(action.payload.type, action.payload.value, state.filterUserData.contacts),

            }
        }),
        addContactReportFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                contactreport: [
                    ...state.filterUserData.contactreport,
                    action.payload
                ]
            }
        }),
        deleteContactReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                contactreport: state.filterUserData.contactreport.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeContactReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                contactreport: setValue(action.payload.type, action.payload.value, state.filterUserData.contactreport),

            }
        }),
        addCallReportFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                callreport: [
                    ...state.filterUserData.callreport,
                    action.payload
                ]
            }
        }),
        deleteCallReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                callreport: state.filterUserData.callreport.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeCallReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                callreport: setValue(action.payload.type, action.payload.value, state.filterUserData.callreport),

            }
        }),
        addConversationReportFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversationreport: [
                    ...state.filterUserData.conversationreport,
                    action.payload
                ]
            }
        }),
        deleteConversationReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversationreport: state.filterUserData.conversationreport.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeConversationReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversationreport: setValue(action.payload.type, action.payload.value, state.filterUserData.conversationreport),

            }
        }),
        addConversationDetailFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversationdetail: [
                    ...state.filterUserData.conversationdetail,
                    action.payload
                ]
            }
        }),
        deleteConversationDetailFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversationdetail: state.filterUserData.conversationdetail.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeConversationDetailFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversationdetail: setValue(action.payload.type, action.payload.value, state.filterUserData.conversationdetail),

            }
        }),
        addCallsFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                calls: [
                    ...state.filterUserData.calls,
                    action.payload
                ]
            }
        }),
        deleteCallsFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                calls: state.filterUserData.calls.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeCallsFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                calls: setValue(action.payload.type, action.payload.value, state.filterUserData.calls),

            }
        }),
        addConversationFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversation: [
                    ...state.filterUserData.conversation,
                    action.payload
                ]
            }
        }),
        deleteConversationFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversation: state.filterUserData.conversation.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeConversationFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                conversation: setValue(action.payload.type, action.payload.value, state.filterUserData.conversation),

            }
        }),
        addOptimizationReportFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                optimizationtemplate: [
                    ...state.filterUserData.optimizationtemplate,
                    action.payload
                ]
            }
        }),
        deleteOptimizationReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                optimizationtemplate: state.filterUserData.optimizationtemplate.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeOptimizationReportFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                optimizationtemplate: setValue(action.payload.type, action.payload.value, state.filterUserData.optimizationtemplate),

            }
        }),
        addChartFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                chart: [
                    ...state.filterUserData.chart,
                    action.payload
                ]
            }
        }),
        setChartFilter: (state, action: PayloadAction<object>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                chart: action.payload
            }
        }),
        deleteChartFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                chart: state.filterUserData.chart.filter((el: any) => el.name !== action.payload),

            }
        }),
        onChangeChartFilter: (state, action: PayloadAction<any>): any => ({
            ...state,
            filterUserData: {
                ...state.filterUserData,
                chart: setValue(action.payload.type, action.payload.value, state.filterUserData.chart),

            }
        }),
        clearChartFilter: (state): any => (
            {
                ...state,
                filterUserData: {
                    ...state.filterUserData,
                    chart: [],

                }
            }),
        clearFilter: (): any => initialState,

    },
})



export const { addContactFilter, deleteContactFilter, onChangeContactFilter, addContactReportFilter, deleteContactReportFilter, onChangeContactReportFilter, addCallReportFilter, deleteCallReportFilter, onChangeCallReportFilter, addConversationReportFilter, deleteConversationReportFilter, onChangeConversationReportFilter, addConversationDetailFilter, deleteConversationDetailFilter, onChangeConversationDetailFilter, addCallsFilter, deleteCallsFilter, onChangeCallsFilter, addConversationFilter, deleteConversationFilter, onChangeConversationFilter, addChartFilter, deleteChartFilter, onChangeChartFilter, setChartFilter, clearChartFilter,
    clearFilter, addOptimizationReportFilter, deleteOptimizationReportFilter, onChangeOptimizationReportFilter } = filterReducer.actions

export default filterReducer.reducer